import { AddButton } from '@/common/buttons/AddButton';
import { ApprButton } from '@/common/buttons/ApprButton';
import { TitleButton } from '@/common/buttons/TitleButton';
import { ValButton } from '@/common/buttons/ValButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { useNavState } from '@/common/navState/NavStateContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useMemo, useRef, useState } from 'react';

export const CtrtList = ({ ownerCustId }) => {
  const { navigateTo } = useNavState();
  const entityListRef = useRef();

  const [selectedEntities, setSelectedEntities] = useState([]);
  const [isCompareDisabled, setIsCompareDisabled] = useState(true);

  const selectedEntityIds = useMemo(() => {
    return selectedEntities.map((selectedEntity) => selectedEntity.id);
  }, [selectedEntities]);

  const anyImplCtrtsSelected = useMemo(() => {
    return selectedEntities.some((entity) => entity.status === 'IMPL');
  }, [selectedEntities]);

  const augNavEntityObj = (navEntityObj) => {
    navEntityObj.amendmentNum = 1;
  };

  const handleSelectionChanged = (event) => {
    const gridApi = event.api;
    const selectedNodeData = gridApi.getSelectedNodes().map((node) => node.data);
    setSelectedEntities(selectedNodeData);

    if (selectedNodeData.length !== 2) {
      setIsCompareDisabled(true);
      return;
    }
    const [first, second] = selectedNodeData;
    setIsCompareDisabled(!(first.typeId && first.typeId === second.typeId));
  };

  const navigateToCtrtCompare = () => {
    const gridApi = entityListRef.current.gridRef.current.gridApiRef.current;
    const selectedCtrts = gridApi.getSelectedRows();
    navigateTo('md/compare/ctrt', { ctrts: selectedCtrts });
  };

  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('status', ['IMPL', 'DRAFT', 'APPROVING']));

      // If in the Customer detail
      if (!ownerCustId) return;
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('ownerCustId', ownerCustId));
    },
    [ownerCustId],
  );

  const augButtons = (buttons) => {
    buttons.pop(); //remove original add button
    buttons.push(
      <AddButton key="addButton" augNavEntityObj={augNavEntityObj} />,
      <ValButton
        key="valButton"
        selectedEntityIds={selectedEntityIds}
        disabledReason={anyImplCtrtsSelected ? 'some selected contracts are in Implemented status' : null}
      />,
      <ApprButton key="apprButton" selectedEntities={selectedEntities} />,
      <TitleButton
        key="compareCtrtButton"
        icon={fas.faBalanceScale}
        disabled={isCompareDisabled}
        toolTip="Compare two Contracts"
        onClick={navigateToCtrtCompare}
      />,
    );
  };

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;
  };

  return (
    <EntityList
      entity="CTRT"
      ref={entityListRef}
      augRowsReq={augRowsReq}
      augButtons={augButtons}
      augFieldDefs={augFieldDefs}
      gridOptions={{
        rowSelection: 'multiple',
      }}
      events={{
        onSelectionChanged: handleSelectionChanged,
      }}
    />
  );
};
